export const CLIENT_PORTAL_USER_STATUSES = {
  ACTIVE: 'ACTIVE',
  INVITED: 'INVITED',
  INACTIVE: 'INACTIVE',
  FAILED: 'FAILED',
};

export const CLIENT_PORTAL_USER_STATUS_LABELS = {
  [CLIENT_PORTAL_USER_STATUSES.ACTIVE]: 'Active',
  [CLIENT_PORTAL_USER_STATUSES.INVITED]: 'Invited',
  [CLIENT_PORTAL_USER_STATUSES.INACTIVE]: 'Inactive',
  [CLIENT_PORTAL_USER_STATUSES.FAILED]: 'Failed',
};

export const CLIENT_PORTAL_TASK_STATUSES = {
  OPEN: 'OPEN',
  COMPLETED: 'COMPLETED',
  CANCEL: 'CANCELLED',
};

export const CLIENT_PORTAL_TASK_STATUS_LABELS = {
  [CLIENT_PORTAL_TASK_STATUSES.OPEN]: 'Open',
  [CLIENT_PORTAL_TASK_STATUSES.COMPLETED]: 'Completed',
  [CLIENT_PORTAL_TASK_STATUSES.CANCEL]: 'Canceled',
};

export const CLIENT_PORTAL_TASK_TYPES = {
  APPROVE: 'APPROVE',
  REVIEW: 'REVIEW',
  PROVIDE_INFORMATION: 'PROVIDE_INFORMATION',
};

export const CLIENT_PORTAL_TASK_TYPE_LABELS = {
  [CLIENT_PORTAL_TASK_TYPES.APPROVE]: 'Approve',
  [CLIENT_PORTAL_TASK_TYPES.REVIEW]: 'Review',
  [CLIENT_PORTAL_TASK_TYPES.PROVIDE_INFORMATION]: 'Provide information',
};
